<template>
    <section class="main-img-section _edit-section">
        <div class="section-inner">
            <div class="main-img-item-wrap">
                <div class="main-img-item form_file-img md_no-image" v-for="(data, key, index) in mainImages" v-bind:key="index" v-bind:class="{_display_none: show_preview}">
                    <a class="md_icon-btn _hover delete" v-if="data !=='/img/no-image.svg'" @click="deleteImage(key)">
                        <div class="md_svg-icon"><SvgIconDelete /></div>
                    </a>
                    <input type="file" v-bind:id="'main-img' + key" accept="image/*" v-bind:data-preview="'_main-img' + key" v-on:change="changeImage($event, key)">
                    <label v-bind:for="'main-img' + key" class="md_icon-btn _hover">
                        <div class="inner"><SvgIconImagePlace /></div>
                    </label>
                    <img class="preview" v-bind:class="'_main-img' + key">
                    <img v-if="data" v-bind:ref="'mainImage' + key" v-bind:src="data" alt="">
                </div>

                <span style="color: red" v-if="$store.state.register.errors.main_images">必須項目を入力してください</span>
            </div>
        </div>
    </section>
    <AlertModal 
        v-if="showAlertModal" 
        @close="closeAlertModal" 
        :title="alert_modal_title" 
        :message="alert_modal_message"
        :mode="alert_modal_mode" 
    />
    <ConfirmModalWithPromise ref="confirmModal" />
</template>

<script>
    import AlertModal from '@/components/EndUser/ComponentList/AlertModal'
    import ConfirmModalWithPromise from '@/components/EndUser/ComponentList/ConfirmModalWithPromise'
    import SvgIconImagePlace from '@/components/EndUser/svg/SvgIconImagePlace'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'

    export default {
        components: {
            "AlertModal": AlertModal,
            "ConfirmModalWithPromise": ConfirmModalWithPromise,
            SvgIconImagePlace,
            SvgIconDelete
        },
        data() {
            return {
                imgSrc: '',
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: ''
            };
        },
        props: {
            mainImages: Object,
            show_preview: Object,
        },
        methods: {
            changeImage(event, key) {
                const target = event.target;
                const dom = eval('this.$refs.mainImage' + key);
                const rect = dom.getBoundingClientRect();
                const file = event.target.files[0];
                const type = file.type;
                const reader = new FileReader()
                if (this.$store.state.const.max_file_size < file.size) {
                    this.openAlertModal('error', 'エラー', this.$store.state.const.file_size_error); // 確認済み
                    return;
                }
                reader.onload = (e) => {
                    this.imgSrc = e.target.result;
                    const imgDatas = {
                        target: target,
                        src: this.imgSrc,
                        type: type,
                        domWidth: rect.width,
                        domHeight: rect.height,
                    }
                this.$emit("openCropper", imgDatas);
                }
                reader.readAsDataURL(file);
                document.getElementById('main-img' + key).value = '';
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';
            },
            async deleteImage(key){
                const confirm = await this.$refs.confirmModal.show({ //確認済み
                    title: '削除してもよろしいですか？',
                    message: '本当に削除してもよろしいですか？',
                    mode: "delete",
                    name: "confirmModalMainImage"
                })
                if(confirm){
                    this.$emit("deleteImage", key, 'main');
                }
            }
        },
    }
</script>
